<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="row mt-2" style="height: 100vh;">
                <div class="col-3">
                    <treeselect
                        :searchable="false"
                        :always-open="true"
                        :options="listLayerMap"
                        :normalizer="normalizer"
                        v-model="selectedLayerMap"
                        placeholder="Chọn bản đồ nền"
                    />
                </div>
                <div class="col-9">
                    <b-row>
                        <b-col> <h5>Bản đồ nền</h5> </b-col>
                        <b-col class="text-right">
                            <b-button
                                class="mb-2"
                                style="width: 200px;"
                                variant="outline-primary"
                                @click="openCreateModal"
                            >
                                <i class="fa fa-plus-circle mr-2"></i>
                                <span class="text-uppercase">Thêm bản đồ nền</span>
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-for="item in listChildLayer" :key="item.id" md="3" sm="4" xs="6">
                            <b-card class="mb-2" align="center">
                                <b-icon
                                    variant="primary"
                                    icon="folder-fill"
                                    font-scale="4"
                                    class="cursor-pointer"
                                    @click="selectedLayerMap = item.id"
                                ></b-icon>
                                <b-card-text
                                    style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                                >
                                    {{ item.name }}
                                </b-card-text>

                                <b-button
                                    variant="primary"
                                    class="mr-2"
                                    @click="openEditModal(item)"
                                    >Sửa</b-button
                                >
                                <b-button variant="danger" @click="openDeleteLayer(item)"
                                    >Xoá</b-button
                                >
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row v-if="selectedLayerMap">
                        <b-col>
                            <h5 class="mt-3">Dữ liệu</h5>
                        </b-col>
                        <b-col class="text-right">
                            <b-button
                                style="width: 200px;"
                                class="mb-2"
                                variant="outline-primary"
                                @click="openUploadModal"
                            >
                                <i class="fa fa-upload mr-2"></i>
                                <span class="text-uppercase">Tải lên dữ liệu</span>
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            v-for="item in listLayerFile"
                            :key="item.id"
                            xl="2"
                            md="3"
                            sm="4"
                            xs="6"
                        >
                            <b-card class="mb-2" align="center">
                                <b-icon
                                    variant="primary"
                                    icon="file-earmark-fill"
                                    font-scale="4"
                                ></b-icon>
                                <b-card-text
                                    style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                                >
                                    {{ item }}
                                </b-card-text>
                                <b-button variant="danger" @click="openDeleteFile(item)"
                                    >Xoá</b-button
                                >
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <b-modal
            ref="createOrUpdateLayerModal"
            ok-title="Lưu"
            :title="`${form.id ? $t('common.update') : $t('common.create')}`"
            @ok="handleCreateLayerOk"
            :cancel-title="$t('common.cancel')"
        >
            <b-form-group label="Tên">
                <b-form-input
                    maxlength="255"
                    v-model="form.name"
                    v-validate="'required'"
                    placeholder="Tên"
                    name="name"
                    data-vv-as="Tên"
                ></b-form-input>
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group label="Chọn icon cho điểm">
                <b-form-file
                    v-model="file"
                    placeholder="Chọn icon"
                    accept="image/*"
                    browse-text="Chọn"
                ></b-form-file>
                <div v-if="form.pointIcon" class="mt-2">
                    <b-button
                        variant="outline-danger"
                        class="float-right"
                        @click="form.pointIcon = null"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-img
                        fluid
                        style="max-width: 50px;"
                        :src="API_CONFIG.BASE_URL + 'download?fileName=' + form.pointIcon"
                    />
                </div>
            </b-form-group>
            <b-form-group label="Kích thước icon">
                <b-form-input
                    v-model="form.iconSize"
                    placeholder="Kích thức icon"
                    v-validate="'required'"
                    name="iconSize"
                    data-vv-as="Kích thức icon"
                    type="number"
                ></b-form-input>
                <div v-show="errors.has('iconSize')" class="validation-message text-danger">
                    {{ errors.first('iconSize') }}
                </div>
            </b-form-group>
            <b-form-group label="Hiển thị mặc định">
                <b-form-checkbox v-model="form.defaultShow" switch></b-form-checkbox>
            </b-form-group>
            <b class="mb-1">Phân cấp màu:</b>
            <b-row class="mb-1">
                <b-col cols="4">
                    <b-form-label>Tên</b-form-label>
                </b-col>
                <b-col cols="3">
                    <b-form-label>Màu sắc</b-form-label>
                </b-col>
                <b-col cols="5">
                    <b-form-label>Giá trị giới hạn</b-form-label>
                </b-col>
            </b-row>
            <b-row v-for="item in legend" :key="item" class="mb-2">
                <b-col cols="4">
                    <b-form-input v-model="item.name"></b-form-input>
                </b-col>
                <b-col cols="3">
                    <b-form-input v-model="item.color" type="color"></b-form-input>
                </b-col>
                <b-col cols="5">
                    <b-row no-gutters>
                        <b-col cols="8">
                            <b-form-input v-model="item.value" type="number"></b-form-input>
                        </b-col>
                        <b-col cols="4" class="pl-2">
                            <b-button
                                variant="danger"
                                @click="legend.splice(legend.indexOf(item), 1)"
                                >Xoá</b-button
                            >
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-button variant="primary" @click="legend.push({ color: '#000' })"
                >Thêm cấp màu</b-button
            >
        </b-modal>

        <b-modal
            ref="uploadDataModal"
            ok-title="Lưu"
            title="Tải lên dữ liệu"
            @ok="handleUploadOk"
            :cancel-title="$t('common.cancel')"
        >
            <b-form-group label="File dữ liệu">
                <b-form-file
                    v-model="file"
                    v-validate="'required'"
                    name="file"
                    placeholder="Chọn file dữ liệu"
                    drop-placeholder="Kéo file dữ liệu vào đây"
                ></b-form-file>
                <div v-show="errors.has('file')" class="validation-message text-danger">
                    {{ errors.first('file') }}
                </div>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import API_CONFIG from '@/api-config';
export default {
    components: {
        Treeselect
    },
    async mounted() {
        await this.$nextTick();
        await this.getData();
    },
    data: function() {
        return {
            API_CONFIG,
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'name',
                    label: 'Tên bản đồ nền'
                },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {
                name: '',
                type: 'base'
            },
            showModalConfirm: false,
            searchKeyword: null,
            listLayer: [],
            selectedLayerMap: null,
            listLayerMap: [],
            listChildLayer: [],
            listLayerFile: [],
            file: null,
            legend: []
        };
    },
    methods: {
        ...mapActions({
            getListLayer: 'mapLayer/getListLayer',
            createLayer: 'mapLayer/createLayer',
            updateLayer: 'mapLayer/updateLayer',
            deleteLayer: 'mapLayer/deleteLayer',
            getLayerTree: 'mapLayer/getListTree',
            getListFile: 'mapLayer/getListFile',
            deleteFile: 'mapLayer/deleteFile',
            uploadFile: 'mapLayer/uploadFile',
            upload: 'file/upload',
            createAuditByUser: 'user/createAuditByUser'
        }),
        async getData() {
            this.listLayer = await this.getListLayer({ type: 'base' });
            this.listChildLayer = this.listLayer;
            this.listLayerMap = await this.getLayerTree({ type: 'base' });
        },
        handleCreateLayerOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        handleUploadOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitUpload();
                }
            });
        },
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.resetForm();
            this.form = { ...item };
            if ((item.legend ?? []).length > 0) this.legend = item.legend;
            this.$refs.createOrUpdateLayerModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateLayerModal.show();
        },
        openUploadModal() {
            this.resetForm();
            this.$refs.uploadDataModal.show();
        },
        resetForm() {
            this.form = {
                name: '',
                type: 'base',
                iconSize: 20
            };
            this.file = null;
            this.legend = [{ color: '#ff0000' }, { color: '#ffa500' }, { color: '#008000' }];
        },
        async submitForm() {
            this.form.legend = this.legend;
            if (this.file) {
                const data = await this.upload({ formData: { file: this.file } });
                this.form.pointIcon = data.path;
            }
            if (this.form.id) {
                await this.updateLayer(this.form);
            } else {
                await this.createLayer({
                    ...this.form,
                    parentId: this.selectedLayerMap
                });
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật bản đồ nền' });
            this.listLayerMap = await this.getLayerTree({ type: 'base' });
            this.listChildLayer = await this.getListLayer({
                type: 'base',
                parentId: this.selectedLayerMap
            });
            this.$refs.createOrUpdateLayerModal.hide();
        },
        async submitUpload() {
            const formData = new FormData();
            formData.append('file', this.file);
            await this.uploadFile({
                id: this.selectedLayerMap,
                formData
            });
            this.listLayerFile = await this.getListFile({ id: this.selectedLayerMap });
            this.listLayerMap = await this.getLayerTree({ type: 'base' });
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Tải lên dữ liệu bản đồ nền' });
            this.$refs.uploadDataModal.hide();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        async openDeleteLayer(item) {
            const result = await this.$bvModal.msgBoxConfirm(
                'Bạn có chắc chắn muốn xoá bản đồ nền này?',
                {
                    title: 'Xác nhận',
                    okVariant: 'danger',
                    okTitle: 'Có',
                    cancelTitle: 'Không'
                }
            );
            if (result) {
                await this.deleteLayer({ id: item.id });
                await this.getData();
                this.$toaster.success('Thành công');
                this.createAuditByUser({ content: 'Xoá bản đồ nền' });
            }
        },
        async openDeleteFile(item) {
            const result = await this.$bvModal.msgBoxConfirm(
                'Bạn có chắc chắn muốn xoá dữ liệu này?',
                {
                    title: 'Xác nhận',
                    okVariant: 'danger',
                    okTitle: 'Có',
                    cancelTitle: 'Không'
                }
            );
            if (result) {
                await this.deleteFile({ id: this.selectedLayerMap, fileName: item });
                this.listLayerFile = await this.getListFile({ id: this.selectedLayerMap });
                this.$toaster.success('Thành công');
                this.createAuditByUser({ content: 'Xoá dữ liệu bản đồ nền' });
            }
        }
    },
    watch: {
        async selectedLayerMap(val) {
            this.listChildLayer = await this.getListLayer({ type: 'base', parentId: val });
            if (val) this.listLayerFile = await this.getListFile({ id: val });
            else this.listLayerFile = [];
        }
    }
};
</script>
<style lang="scss" scoped></style>
